import {
  buildOnePlusManyInstanceId,
  isOnePlusManyInstanceId,
  ONE_PLUS_MANY_INSTANCE_PATTERN,
  OnePlusManyInstanceId,
  parseOnePlusManySuffix
} from 'constants/bodyBlocks';
import { StoreBodyBlock } from 'constants/enums';

export const FIRST_INSTANCE_SUFFIX = 1;

export const buildOnePlusManyV2ItemId = (blockId: string): string =>
  blockId.startsWith('bb-') ? blockId : `bb-${blockId}`;

export const parseOnePlusManyInstanceKeyFromWireId = (
  wireId: string
): OnePlusManyInstanceId | undefined => {
  const match = wireId.match(/onePlusMany_(\d+)/);
  if (!match) return undefined;
  return buildOnePlusManyInstanceId(Number(match[1]));
};

const resolveOnePlusManyInstanceKey = (entry: {
  id?: unknown;
  instanceKey?: unknown;
}): OnePlusManyInstanceId | undefined => {
  if (typeof entry.instanceKey === 'string' && isOnePlusManyInstanceId(entry.instanceKey)) {
    return entry.instanceKey;
  }
  if (typeof entry.id === 'string') {
    const fromWireId = parseOnePlusManyInstanceKeyFromWireId(entry.id);
    if (fromWireId !== undefined) return fromWireId;
    if (isOnePlusManyInstanceId(entry.id)) return entry.id;
  }
  return undefined;
};

const collectOnePlusManyStoreBlockIds = (value: unknown): OnePlusManyInstanceId[] => {
  if (!Array.isArray(value)) return [];
  const ids: OnePlusManyInstanceId[] = [];
  for (const entry of value) {
    const instanceKey = resolveOnePlusManyInstanceKey(
      entry as { id?: unknown; instanceKey?: unknown }
    );
    if (instanceKey !== undefined) {
      ids.push(instanceKey);
    }
  }
  return ids;
};

export const collectOnePlusManySuffixes = (
  formValues: Record<string, unknown>
): number[] =>
  collectOnePlusManyStoreBlockIds(formValues.storeBlocks)
    .map((id) => parseOnePlusManySuffix(id))
    .sort((a, b) => a - b);

export const computeNextOnePlusManySuffix = (
  formValues: Record<string, unknown>
): number => {
  const suffixes = collectOnePlusManySuffixes(formValues);
  if (suffixes.length === 0) return FIRST_INSTANCE_SUFFIX;
  return Math.max(...suffixes) + 1;
};

export const computeNextOnePlusManyBlockId = (
  formValues: Record<string, unknown>
): OnePlusManyInstanceId =>
  buildOnePlusManyInstanceId(computeNextOnePlusManySuffix(formValues));

export {
  buildOnePlusManyInstanceId,
  isOnePlusManyInstanceId,
  ONE_PLUS_MANY_INSTANCE_PATTERN,
  parseOnePlusManySuffix,
  StoreBodyBlock
};
export type { OnePlusManyInstanceId };
